import { render, staticRenderFns } from "./IconDownload.vue?vue&type=template&id=b5498966&scoped=true"
import script from "./IconDownload.vue?vue&type=script&lang=js"
export * from "./IconDownload.vue?vue&type=script&lang=js"
import style0 from "./IconDownload.vue?vue&type=style&index=0&id=b5498966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5498966",
  null
  
)

export default component.exports